import { Route, Routes } from "react-router-dom";
import { AnimatePresence } from "motion/react";
import { Suspense } from "react";

import ScrollToTop from "./wrappers/wrapper.scrollToTop";
import CustomLoader from "@components/loader.page";

import { publicRoutes } from "./router.routes.jsx";
import { useRoleRoutes } from "./wrappers/wrapper.roleRoutes.jsx";
import ProtectedLayout from "./wrappers/wrapper.protectedLayout.jsx";
import RouterProvider from "./wrappers/wrapper.routerProvider.jsx";
import {
  renderPublicRoutes,
  renderPrivateRoutes,
} from "./wrappers/wrapper.routeRenderer.jsx";

export default function Router() {
  const activeRoutes = useRoleRoutes();

  return (
    <RouterProvider>
      <ScrollToTop />

      <AnimatePresence mode="wait">
        <Suspense fallback={<CustomLoader />}>
          <Routes>
            {/* Public */}
            
            {renderPublicRoutes(publicRoutes)}

            {/* Private */}
            <Route path="/" element={<ProtectedLayout />}>
              {renderPrivateRoutes(activeRoutes)}
            </Route>
          </Routes>
        </Suspense>
      </AnimatePresence>
    </RouterProvider>
  );
}
